import { render, staticRenderFns } from "./AboutSession.vue?vue&type=template&id=224cfc7e&scoped=true"
import script from "./AboutSession.vue?vue&type=script&lang=js"
export * from "./AboutSession.vue?vue&type=script&lang=js"
import style0 from "./AboutSession.vue?vue&type=style&index=0&id=224cfc7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224cfc7e",
  null
  
)

export default component.exports